export const buildFormData = (formData: FormData, data: any, parentKey: string | null = null) => {
    if (data && typeof data === 'object' && !(data instanceof File)) {
      Object.entries(data).forEach(([key, value]) => {
        const newKey = parentKey ? `${parentKey}[${key}]` : key;
        buildFormData(formData, value, newKey);
      });
    } else {
      formData.append(parentKey!, data);
    }
};
